module.exports = __webpack_public_path__ + "static/media/ClaireHutchinson-7.64721d93.png";